module.exports = __webpack_public_path__ + "img/kzys-currency-guide-ko.97fc7e34.png";